import React, { useEffect, useState } from "react";
import { MessageBar, MessageBarType, Spinner, Stack } from "@fluentui/react";
import axios from "axios";
import SignInForm from "./SignInForm.js";

const TokenValidationWrapper = ({ children }) => {
  const [isValid, setIsValid] = useState(null); // Tracks the validity of the token
  const [errorMessage, setErrorMessage] = useState(null);

  const validateToken = async () => {
    const token = localStorage.getItem("wlp-token");

    if (!token) {
      setErrorMessage("No token found. Please sign in.");
      setIsValid(false);
      return;
    }

    try {
      // Replace '/api/validate-token' with your server's token validation endpoint
      const response = await axios.post(
        "/api/validate-token",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.valid) {
        setIsValid(true);
      } else {
        setErrorMessage("Invalid token. Please sign in again.");
        setIsValid(false);
      }
    } catch (error) {
      console.error("Error validating token:", error);
      setErrorMessage(
        error.response?.data?.error || "An error occurred while validating the token."
      );
      setIsValid(false);
    }
  };

  useEffect(() => {
    validateToken();
  }, []);

  if (isValid === null) {
    return (
      <Stack
        horizontalAlign="center"
        verticalAlign="center"
        styles={{ root: { height: "100vh" } }}
      >
        <Spinner label="Validating token..." />
      </Stack>
    );
  }

  if (!isValid) {
    return <SignInForm successCallback={validateToken} />
  }

  return <>{children}</>;
};

export default TokenValidationWrapper;
